import { Card, CardContent, Box, Typography, Chip } from '@material-ui/core';
import { TrendingUp, TrendingDown } from '@material-ui/icons';
import Chart from 'react-apexcharts';
import chartRegistry from './charts/chartRegistry';

// Thin router: looks up the dedicated chart component for the selected
// metric and renders it. Each chart owns its own dataset and visualization.
const MetricDetail = ({ data }) => {
  const ChartComponent = chartRegistry[data.id];

  if (!ChartComponent) {
    return (
      <Card elevation={2}>
        <CardContent>
          <Typography variant="h6" color="text.primary">
            {data.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            No chart is configured for this metric yet.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return <ChartComponent metric={data} />;
};

export default MetricDetail;
